<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems" />
    <div class="row pb-5">
      <sys-widget title="Cantidad de Movimientos" :content="meta.total" icon="users" />
      <sys-widget title="Monto Total" :content="meta.total_amount | formatCurrency" icon="dollar-sign" color="secondary"/>
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import movementsService from '@/services/movements'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'
import reverseDate from '@/filters/reverseDate'

export default {
  name: 'Movements',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Movimientos',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Colaborador', value: 'full_name' },
        { text: 'Cuenta', value: 'account_id' },
        { text: 'Sueldo', value: 'salary', filter: formatCurrency },
        { text: 'Monto de Movimiento', value: 'amount', filter: formatCurrency },
        { text: 'Estatus', value: 'status' },
        { text: 'Fecha de Confirmación', value: 'confirm_date' },
        { text: '¿Es Total?', value: 'total' }
      ],
      items: [],
      filtered_items: [],
      items_sum: 0,
      error_message: 'There\'s nothing to show :c',
      detail_route: 'movement',
      create_route: 'movement_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'full_name',
          name: 'Nombre',
          hint: 'Colaborador',
          icon: 'user',
          type: 'text',
          value: '',
          size: 3,
          validator: (item, value) => item.full_name.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'income',
          name: 'Estatus',
          hint: 'Todos',
          icon: 'user',
          type: 'select',
          options: [{ value: 0, text: 'Retiro' },
            { value: 1, text: 'Aportación' }],
          size: 3,
          validator: (item, value) => item.income.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'date_from',
          name: 'Fecha Desde',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.confirm_date) >= new Date(reverseDate(value))
        },
        {
          id: 'date_to',
          name: 'Fecha Hasta',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.confirm_date) <= new Date(reverseDate(value))
        },
        {
          id: 'investment_from',
          name: 'Monto Desde',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.amount >= value
        },
        {
          id: 'investment_to',
          name: 'Monto Hasta',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.amount <= value
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      movementsService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/movements/Movements.vue